export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-24 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4">
              每日更新推荐 · 告别片荒
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              91电影
              <span className="block md:inline text-xl md:text-3xl lg:text-4xl text-foreground-700 font-normal md:ml-3">
                全网最全国产电影聚集地
              </span>
            </h1>

            <p className="mt-3 text-sm md:text-base text-primary-600 font-medium">
              免费高清看国货精品，每天发现好电影
            </p>

            <div className="mt-5 max-w-xl lg:max-w-none">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                国产91电影大全每日精选最新国产大片，覆盖动作、悬疑、喜剧、文艺等多种类型。无论你是追新片还是补经典，这里都能找到值得一看的国货好片。平台持续更新，内容覆盖院线热门与口碑佳作，帮你高效筛选、精准推荐。
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              {[
                { value: '2000+', label: '国产影片收录' },
                { value: '每日更新', label: '最新推荐' },
                { value: '全类型', label: '题材覆盖' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-movie-2-line"></i>
                探索精选推荐
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                查看热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg xl:max-w-xl">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20cinema%20film%20reel%20warm%20red%20gold%20atmospheric%20lighting%2C%20movie%20projector%20beam%20on%20dark%20background%2C%20cinematic%20composition%20with%20soft%20bokeh%2C%20elegant%20theater%20ambiance%2C%20dramatic%20lighting%20contrast%2C%20artistic%20film%20aesthetic%2C%20warm%20toned%20Chinese%20movie%20poster%20style%20illustration%20with%20gold%20accents%20and%20deep%20crimson%20highlights&width=1200&height=900&seq=hero-movie-2026&orientation=landscape"
                alt="91电影 - 国产电影精选推荐主视觉"
                className="w-full h-auto rounded-xl object-cover"
                style={{ aspectRatio: '4/3' }}
              />
              <div className="absolute inset-0 rounded-xl bg-gradient-to-t from-background-950/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}